import { moduleProviderFactory } from 'core/providers';
import { InsuranceManagementEdit, InsuranceManagementList } from 'application/insurance-management/pages';

(function () {
    moduleProviderFactory.application.register({
        routes: [
            {
                name: 'master.app.main.insurance-management',
                pattern: '/insurance-management',
                children: [
                    {
                        name: 'master.app.main.insurance-management.list',
                        pattern: '',
                        tabTitle: 'INSURANCE_MANAGEMENT.LIST.TITLE_SECONDARY',
                        component: InsuranceManagementList,
                        data: {
                            title: 'INSURANCE_MANAGEMENT.LIST.TITLE_SECONDARY'
                        }
                    },
                    {
                        name: 'master.app.main.insurance-management.create',
                        pattern: '/create',
                        tabTitle: 'INSURANCE_MANAGEMENT.CREATE.TAB_TITLE',
                        component: InsuranceManagementEdit,
                        authorization: 'portalSection.create',
                        data: {
                            title: 'INSURANCE_MANAGEMENT.CREATE.TITLE'
                        },
                    },
                    {
                        name: 'master.app.main.insurance-management.edit',
                        pattern: '/edit/:id',
                        tabTitle: 'INSURANCE_MANAGEMENT.EDIT.TAB_TITLE',
                        component: InsuranceManagementEdit,
                        authorization: 'portalSection.update',
                        data: {
                            title: 'INSURANCE_MANAGEMENT.EDIT.TITLE'
                        },
                    }                 
                ]
            }
        ],
        menu: [
            {
                title: 'MENU.MASTER_DATA',
                order: 7,
                icon: 'database',
                authorization: 'administrationSection.read',
                subMenu: [
                    {
                        title: 'MENU.INSURANCE_MANAGEMENT_SUB',
                        route: 'master.app.main.insurance-management.list',
                        order: 5.1,
                    }                    
                ]
            }
        ]
    });
})();
